const initalState = []

const authReducer = (state = initalState, action) => {
	const {type, data} = action

	switch (type) {
		case "FETCH_AUTH":
			return data
		
		default:
			return state
	}
}


export {authReducer}